import React from 'react';
import HomeHero from '../HomeHero/HomeHero';
import HomeVideo from '../HomeHero/HomeVideo';
import HomeTestimonials from '../HomeTestimonials/HomeTestimonials';
import HomeProof from '../HomeProof/HomeProof';
import HomeSchools from '../HomeSchools/HomeSchools';
import HomeContexts from '../HomeContexts/HomeContexts';
import HomeTools from '../HomeTools/HomeTools';
import HomePricing from '../HomePricing/HomePricing';
import HomeFaq from '../HomeFaq/HomeFaq';
import HomeContact from '../HomeContact/HomeContact';

const HomeLanding = ({ language }) => {
    return (
        <>
            {/* Every section is responsive on its own, so the page is one list
                rather than the Desktop/Tablet/Mobile triplets it used to be.
                The order is the design's, minus its "why we built VBoard" band,
                dropped on request: top -> video -> contexte -> instrumente ->
                dovezi -> scoli -> preturi -> FAQ -> contact. */}
            <HomeHero />
            <HomeTestimonials />
            <HomeVideo language={language} />
            <HomeContexts />
            <HomeTools />
            <HomeProof />
            <HomeSchools />
            <HomePricing />
            <HomeFaq />
            <HomeContact />
        </>
    );
};

export default HomeLanding;
